/**
 * @packageDocumentation
 * @module f1/array
 */

export interface Range {
  /**
   * A pure function to generate a range of numbers from start(including) to end(excluding)
   *
   * @public
   * @function f1.
   * @param offset the step to take for each index
   * @param start the first value to count from
   * @param end the control for the size of the array
   * @example
   *
   * ```ts
   * f1.range(1, 1, 5) => [1, 2, 3, 4, 5]
   * ```
   *
   */
  (offset: number, start: number, end: number): number[];
  (offset: number, start: number): (end: number) => number[];
}

/**
 * @see Range
 */
export default (offset: number, start: number, end: number) => {
  const arr: number[] = [];
  let c = start;

  for (; c <= end; c += offset) {
    arr.push(c);
  }

  return arr;
};
